import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { PageHeader } from "@/components/Layout";
import { Chip, EmptyState } from "@/components/Bits";
import api from "@/lib/api";

function sevChip(s) {
  if (s === "High") return "bg-[#FF3B30]/10 border-[#FF3B30]/30 text-[#FF6259]";
  if (s === "Medium") return "bg-[#FFD600]/10 border-[#FFD600]/30 text-[#FFD600]";
  return "bg-white/5 border-white/15 text-zinc-400";
}

export default function ActionCenter() {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const load = useCallback(() => api.get("/action-center").then((r) => setRows(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const resolve = async (id, resolution) => {
    await api.post(`/action-center/${id}/resolve?resolution=${encodeURIComponent(resolution)}`);
    toast.success(`Marked ${resolution}`); load();
  };

  return (
    <div>
      <PageHeader title="Action Center" subtitle="Only exceptions needing attention — manage by exception" />
      <div className="p-8">
        {rows.length === 0 ? <EmptyState icon={ShieldCheck} title="All clear" hint="No open exceptions right now." /> : (
          <div className="space-y-3">
            {rows.map((e) => (
              <div key={e.id} data-testid={`exception-${e.id}`} className="bg-[#121212] border border-white/10 rounded-sm p-5 flex items-center justify-between gap-4">
                <div className="flex items-center gap-3 min-w-0">
                  <AlertTriangle size={18} className="text-[#FF9500] shrink-0" />
                  <div className="min-w-0">
                    <div className="flex items-center gap-2"><span className="text-sm text-zinc-200">{e.type}</span><Chip className={sevChip(e.severity)}>{e.severity}</Chip></div>
                    <div className="text-xs text-zinc-500 mt-0.5">{e.message}</div>
                    {e.order_ref && <button onClick={() => e.order_id && navigate(`/orders/${e.order_id}`)} className="text-[10px] font-mono uppercase tracking-wider text-[#4DA3FF] hover:underline mt-1">{e.order_ref}</button>}
                  </div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  {(e.actions || ["Resolve"]).slice(0, 3).map((a) => (
                    <button key={a} data-testid={`resolve-${e.id}`} onClick={() => resolve(e.id, a)} className="text-[10px] font-mono uppercase tracking-wider border border-white/15 text-zinc-300 hover:bg-white/5 px-2.5 py-1 rounded-sm transition-colors">{a}</button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
